export const fallbackShortDateFormat = "DD/MM/YYYY";
